module.exports = __webpack_public_path__ + "img/logo-vodafone.ce1f59d8.svg";